module.exports = __webpack_public_path__ + "img/promo_49.862b5821.jpeg";